module.exports = __webpack_public_path__ + "images/category_lp/art_work/assessment_achievements/3_1dfe710fac10dfab5538f5f6f17d8191.jpg";